import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, User } from 'lucide-react';

const ContactSection = ({ content }) => {
  return (
    <section
      id="contact"
      className="min-h-screen py-24 bg-gradient-to-br from-[#003366] to-[#001f3f] flex items-center"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {content.title}
          </h2>
          <p className="text-xl text-blue-100 mb-12 max-w-2xl mx-auto">
            {content.subtitle}
          </p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 shadow-2xl"
          >
            <div className="space-y-6">
              <motion.div
                className="flex items-center justify-center space-x-4"
                whileHover={{ scale: 1.05 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <User className="w-6 h-6 text-white" />
                <span className="text-xl text-white font-semibold">
                  {content.name}
                </span>
              </motion.div>

              <motion.a
                href={`tel:${content.phone}`}
                className="flex items-center justify-center space-x-4 text-blue-100 hover:text-white transition-colors"
                whileHover={{ scale: 1.05 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <Phone className="w-6 h-6" />
                <span className="text-xl">{content.phone}</span>
              </motion.a>

              <motion.a
                href={`mailto:${content.email}`}
                className="flex items-center justify-center space-x-4 text-blue-100 hover:text-white transition-colors"
                whileHover={{ scale: 1.05 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <Mail className="w-6 h-6" />
                <span className="text-xl">{content.email}</span>
              </motion.a>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;


